var _circle, _circle2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "url(#paint0_linear_367_99)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "black",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8065 9.5C19.4149 9.5 19.9845 9.80441 20.3303 10.3143L21.1235 11.4842C21.4692 11.9941 22.0388 12.2985 22.6472 12.2985H23.5046C24.5148 12.2985 25.3337 13.1326 25.3337 14.1616V21.7804C25.3337 22.8221 24.5046 23.6667 23.4818 23.6667H10.5188C9.49609 23.6667 8.66699 22.8221 8.66699 21.7804V14.1848C8.66699 13.1431 9.49609 12.2985 10.5188 12.2985H11.4058C12.0263 12.2985 12.6057 11.9819 12.9488 11.4552L13.6732 10.3433C14.0163 9.81662 14.5956 9.5 15.2162 9.5H18.8065ZM18.9819 11.3516C18.9045 11.236 18.7746 11.1667 18.6356 11.1667H15.3927C15.2509 11.1667 15.1189 11.2388 15.0422 11.358L14.4201 12.3255C13.7558 13.3589 12.6611 14.0043 11.4702 14.0767L11.2459 14.0835H10.7503C10.5202 14.0835 10.3337 14.27 10.3337 14.5001V21.5833C10.3337 21.8135 10.5202 22 10.7503 22H23.2503C23.4804 22 23.667 21.8135 23.667 21.5833V14.4996C23.667 14.2693 23.4802 14.0827 23.2498 14.083L22.8086 14.0835C21.6306 14.0835 20.5234 13.5214 19.8042 12.5691L19.674 12.386L18.9819 11.3516ZM17.0003 12.8333C19.3015 12.8333 21.167 14.6988 21.167 17C21.167 19.3012 19.3015 21.1667 17.0003 21.1667C14.6991 21.1667 12.8337 19.3012 12.8337 17C12.8337 14.6988 14.6991 12.8333 17.0003 12.8333ZM17.0003 14.5C15.6196 14.5 14.5003 15.6193 14.5003 17C14.5003 18.3807 15.6196 19.5 17.0003 19.5C18.381 19.5 19.5003 18.3807 19.5003 17C19.5003 15.6193 18.381 14.5 17.0003 14.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_367_99",
    x1: 6.62712,
    y1: 4.8983,
    x2: 28.2373,
    y2: 27.9492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4061A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A98D1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.f09a4d2fa8533adaefa5d50292f5cdd9.svg";
export { ForwardRef as ReactComponent };